// This file was autogenerated from /frontend/sail-next/packages/docs/src/examples/Chip/Suggested.story.tsx with go/sail-next-tailor-docs-publisher

import * as React from 'react';
import {Chip} from '@sail/ui';
import {Container} from './common';

export const Suggested = () => (
  <Container>
    <Chip
      label="Date"
      onAddSuggestion={() => {
        // eslint-disable-next-line no-alert
        alert('Suggestion function triggered');
      }}
    />
  </Container>
);
